__turbopack_context__.v({
  "primary": "Default-module__1BbqHa__primary",
  "secondary": "Default-module__1BbqHa__secondary",
  "svgIcon": "Default-module__1BbqHa__svgIcon",
  "tertiary": "Default-module__1BbqHa__tertiary",
  "transparent": "Default-module__1BbqHa__transparent",
  "useStroke": "Default-module__1BbqHa__useStroke",
});
